export default __webpack_public_path__ + "static/char-s-09-chs-26cbccc321d8910fa1f9b600c8cb6eec.webp";